import type { ReactNode } from "react";
import { useCallback } from "react";
import { connect } from "react-redux";

import actions from "@/actions";

import Button from "../base/Button";

const renderIcon = (color: string): ReactNode => (
    <svg width="35px" height="31px" viewBox="0 0 35 31" version="1.1">
        <title>redo</title>
        <desc>Created with Sketch.</desc>
        <defs />
        <g
            id="Symbols---Zep"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g
                id="LS-Menu"
                transform="translate(-693.000000, -14.000000)"
                stroke={color}
            >
                <g id="redo">
                    <g transform="translate(693.000000, 14.000000)">
                        <polyline
                            id="Shape"
                            points="34 23 1 23 1 1 24.5714286 1"
                        />
                        <polyline
                            id="Shape"
                            strokeLinecap="square"
                            points="26 15 34 23 26 31"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

interface RedoButtonProps extends Partial<React.ComponentProps<typeof Button>> {
    mode: string;
    onClick?: () => void;
    onGlobalRedo: () => void;
    onModeRedo: () => void;
}

const RedoButton = (props: RedoButtonProps) => {
    const { mode, onGlobalRedo, onModeRedo, onClick, ...buttonProps } = props;

    const handleClick = useCallback(() => {
        onClick?.();
        if (mode === "view") {
            onGlobalRedo();
        } else {
            onModeRedo();
        }
    }, [mode, onGlobalRedo, onModeRedo, onClick]);

    return (
        <Button
            {...buttonProps}
            onClick={handleClick}
            renderIcon={renderIcon}
        />
    );
};

/**
 * Determines whether the redo action is disabled based on mode history and paste state.
 *
 * @param map - The Redux map state containing mode history.
 * @returns Whether the redo action is disabled.
 */
const isDisabled = (map: any) =>
    map.general.mode.name === "view"
        ? map.values.global.future.length === 0
        : map.values.mode.future.length === 0 ||
          map.general.pasteMode.activated;

const mapStateToProps = ({ map }: { map: any }) => {
    return {
        disabled: isDisabled(map),
        mode: map.general.mode.name,
    };
};

const mapDispatchToProps = {
    onGlobalRedo: actions.map.values.global.redo,
    onModeRedo: actions.map.values.mode.redo,
};

export default connect(mapStateToProps, mapDispatchToProps)(RedoButton);
